import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedAdmin({ children }) {
    const { admin, checking } = useAuth();
    if (checking)
        return (
            <div className="min-h-screen flex items-center justify-center text-[#4a5568]">
                Checking session…
            </div>
        );
    if (!admin) return <Navigate to="/admin/login" replace />;
    return children;
}
